import axios from "axios";

export const callGetAPI = async (url) => {
  const result = await axios.get(process.env.REACT_APP_API_URL + url);
  return result.data;
};

export const callPostAPI = async (url, data) => {
  const result = await axios.post(process.env.REACT_APP_API_URL + url, data);
  return result.data;
};
